/** ! WARNING: DO NOT EDIT ! **
  This file is generated by graphql codegen.
  Make changes to *.graphql documents, not this file
**/
import type * as _Types from '_gql';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type GetTokenForMobileQRCode_requestApplicantToken_Auth = { readonly __typename: 'Auth', readonly token: string };

export type GetTokenForMobileQRCode_Mutation = { readonly __typename: 'Mutation', readonly requestApplicantToken: GetTokenForMobileQRCode_requestApplicantToken_Auth | null };


export type GetTokenForMobileQRCodeVariables = _Types.Exact<{
  salesforceCreditId: _Types.Scalars['ID']['input'];
}>;


export type GetTokenForMobileQRCode = GetTokenForMobileQRCode_Mutation;


export const GetTokenForMobileQRCodeDocument = gql`
    mutation GetTokenForMobileQRCode($salesforceCreditId: ID!) {
  requestApplicantToken(creditApplicationId: $salesforceCreditId) {
    token
  }
}
    `;
export type GetTokenForMobileQRCodeMutationFn = Apollo.MutationFunction<GetTokenForMobileQRCode, GetTokenForMobileQRCodeVariables>;

/**
 * __useGetTokenForMobileQRCode__
 *
 * To run a mutation, you first call `useGetTokenForMobileQRCode` within a React component and pass it any options that fit your needs.
 * When your component renders, `useGetTokenForMobileQRCode` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [getTokenForMobileQrCode, { data, loading, error }] = useGetTokenForMobileQRCode({
 *   variables: {
 *      salesforceCreditId: // value for 'salesforceCreditId'
 *   },
 * });
 */
export function useGetTokenForMobileQRCode(baseOptions?: Apollo.MutationHookOptions<GetTokenForMobileQRCode, GetTokenForMobileQRCodeVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<GetTokenForMobileQRCode, GetTokenForMobileQRCodeVariables>(GetTokenForMobileQRCodeDocument, options);
      }
export type GetTokenForMobileQRCodeHookResult = ReturnType<typeof useGetTokenForMobileQRCode>;
export type GetTokenForMobileQRCodeMutationResult = Apollo.MutationResult<GetTokenForMobileQRCode>;
export type GetTokenForMobileQRCodeMutationOptions = Apollo.BaseMutationOptions<GetTokenForMobileQRCode, GetTokenForMobileQRCodeVariables>;